jQuery(document).ready(function ($) {
    if ($('.exteriors-slider').length) {
        $('.exteriors-slider').slick({
            dots: false, // removed dots
            infinite: true,
            speed: 600,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="dashicons dashicons-arrow-left-alt2"></i></button>',
            nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="dashicons dashicons-arrow-right-alt2"></i></button>',
        });
    }

    if ($('.apartment-interior-slider').length) {
        $('.apartment-interior-slider').slick({
            dots: false,
            infinite: true,
            speed: 1500, // 1.5 second animation
            fade: true, // Smooth fade transition
            cssEase: 'ease-in-out',
            autoplay: true,
            autoplaySpeed: 5000, // 5 seconds between slides
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="dashicons dashicons-arrow-left-alt2"></i></button>',
            nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="dashicons dashicons-arrow-right-alt2"></i></button>',
        });
    }

    // Amenities & Floorplan Lightbox Logic
    $('.amenity-card, .floorplan-lightbox-trigger').on('click', function () {
        var largeImgUrl = $(this).attr('data-large-image');
        var captionText = $(this).attr('data-name');

        $('#lightbox-img').attr('src', largeImgUrl);
        $('#lightbox-caption').text(captionText);
        $('#amenities-lightbox').addClass('active');
        $('body').addClass('lightbox-open'); // Lock scrolling
    });

    function closeLightbox() {
        $('#amenities-lightbox').removeClass('active');
        $('body').removeClass('lightbox-open'); // Unlock scrolling
        setTimeout(function () {
            $('#lightbox-img').attr('src', '');
            $('#lightbox-caption').text('');
        }, 300);
    }

    $('.lightbox-close, #amenities-lightbox').on('click', function (e) {
        if ($(e.target).is('.lightbox-close') || $(e.target).is('#amenities-lightbox')) {
            closeLightbox();
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $('#amenities-lightbox').hasClass('active')) {
            closeLightbox();
        }
    });

    // Apartment Tabs Switch Logic
    $('.apartment-tab-btn').on('click', function () {
        var tabId = $(this).attr('data-tab');
        var $container = $(this).closest('.apartment-tabs-container');

        // Remove active class from buttons and panes within this container
        $container.find('.apartment-tab-btn').removeClass('active');
        $container.find('.apartment-tab-pane').removeClass('active');

        // Add active class to clicked button and target pane
        $(this).addClass('active');
        var $activePane = $('#' + tabId);
        $activePane.addClass('active');

        // Refresh slick slider inside the newly activated tab
        var $slider = $activePane.find('.apartment-interior-slider');
        if ($slider.length && $slider.hasClass('slick-initialized')) {
            $slider.slick('setPosition');
        }
    });
});